(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ribi-air-purifiers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ribi-air-collection')) {
  customElements.define('ribi-air-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const cards = [...this.querySelectorAll('[data-air-model]')];
      const buttons = [...this.querySelectorAll('[data-air-brand]')];
      const count = this.querySelector('[data-air-count]');
      const toolbar = this.querySelector('.ra-toolbar');
      if (!toolbar || !count) return;
      count.textContent = cards.length;
      toolbar.hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => {
        const brand = button.dataset.airBrand;
        buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        let visible = 0;
        cards.forEach(card => {
          card.hidden = brand !== 'all' && card.dataset.airModel !== brand;
          if (!card.hidden) visible++;
        });
        count.textContent = visible;
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
